/**
 * BEST AGENT — Enterprise Design System
 * Shared tokens, components & utilities
 */

export const DS = {
  // Colors
  navy:       '#0A192F',
  navy2:      '#112240',
  navy3:      '#172A45',
  gold:       '#B7955B',
  gold2:      '#A18048',
  goldSoft:   '#F5EFE3',
  bg:         '#F0F2F5',
  surface:    '#FFFFFF',
  border:     '#E8ECF2',
  border2:    '#CDD1DA',
  text:       '#0D1829',
  muted:      '#5A6478',
  muted2:     '#94A3B8',

  // Semantic
  success:    '#16A34A',
  successBg:  '#F0FDF4',
  successBorder: '#BBF7D0',
  warning:    '#D97706',
  warningBg:  '#FFFBEB',
  warningBorder: '#FDE68A',
  danger:     '#DC2626',
  dangerBg:   '#FEF2F2',
  dangerBorder: '#FECACA',
  info:       '#2563EB',
  infoBg:     '#EFF6FF',
  infoBorder: '#BFDBFE',

  // Radius
  r1: 2,
  r2: 3,
  r3: 4,
  r4: 6,
  r5: 8,

  // Shadows
  shadow1: '0 1px 2px rgba(10,25,47,0.04)',
  shadow2: '0 4px 12px rgba(10,25,47,0.08)',
  shadow3: '0 8px 24px rgba(10,25,47,0.12)',
  shadow4: '0 16px 48px rgba(10,25,47,0.14)',
};

// Reusable inline styles
export const styles = {
  card: {
    background: '#FFFFFF',
    border: `1px solid ${DS.border}`,
    borderRadius: DS.r3,
    boxShadow: DS.shadow1,
  },
  cardHover: {
    boxShadow: DS.shadow3,
    transform: 'translateY(-2px)',
  },
  btnPrimary: {
    background: DS.navy,
    color: '#fff',
    borderRadius: DS.r1,
    fontSize: 13,
    fontWeight: 500,
    padding: '8px 16px',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    transition: 'background 150ms ease',
  },
  btnSecondary: {
    background: '#fff',
    color: DS.text,
    borderRadius: DS.r1,
    fontSize: 13,
    fontWeight: 500,
    padding: '8px 16px',
    border: `1px solid ${DS.border}`,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    transition: 'border-color 150ms ease',
  },
  btnGold: {
    background: DS.gold,
    color: '#fff',
    borderRadius: DS.r1,
    fontSize: 13,
    fontWeight: 500,
    padding: '8px 16px',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
  },
  input: {
    background: '#F8FAFC',
    border: `1px solid ${DS.border}`,
    borderRadius: DS.r1,
    padding: '9px 14px',
    fontSize: 13,
    color: DS.text,
    outline: 'none',
    width: '100%',
    transition: 'border-color 150ms, background 150ms',
  },
  label: {
    fontSize: 10,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.15em',
    color: DS.muted2,
    display: 'block',
    marginBottom: 6,
  },
  sectionTitle: {
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: '1.05rem',
    fontWeight: 300,
    color: DS.text,
    letterSpacing: '-0.01em',
  },
  pageSubtitle: {
    fontSize: 10,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.22em',
    color: DS.gold,
    marginBottom: 2,
  },
  divider: {
    borderTop: `1px solid ${DS.border}`,
    margin: '0',
  },
  badge: (color = DS.muted, bg = '#F1F5F9') => ({
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: DS.r1,
    fontSize: 10,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    color,
    background: bg,
  }),
};
